export default __webpack_public_path__ + "static/media/favicon.9c8faee1.png";